import React, { useEffect, useLayoutEffect, useRef } from 'react';
import { Controls, Divider, FooterText, FormBox, Wrapper } from './login-step.styles';
import { Button } from '@vtbhome/juicyfront';
import { AllUser } from '@vtbhome/juicyfront/indexIcon';
import { Field, Form } from 'react-final-form';
import { LoginFormKeys } from '../../config/form-login-constants';
import { useDispatch } from 'react-redux';
import { setLogin, setLoginStep } from '../../model/slice';
import { validate } from '../../lib/form-login-validate/form-login-validate';
import { useLoginSelector, useLoginStepSelector } from '@features/current-user/login/model/selectors';
import { useRequestPasswordMutation } from '../../api/login-api';
import { LoginSteps } from '../../model/types';
import { Typography } from '@shared/ui/typography/typography';
import { InputText } from '@shared/ui/input-text/input-text';
import { ROUTE_REGISTER } from '@shared/config/routes/routes';
import { getQueryError } from '@shared/lib/utils/get-query-error/get-query-error';
import { LinkScroll } from '@shared/ui/link-scroll/link-scroll';
import { REQUEST_PASSWORD_TIMER_KEY } from '../../config/form-password-constants';

export const LoginStep: React.FC = () => {
    const currentStep = useLoginStepSelector();
    const dispatch = useDispatch();
    const inputRef = useRef<HTMLLabelElement | null>(null);
    const [requestPassword, requestPasswordResult] = useRequestPasswordMutation();
    const initialLogin = useLoginSelector();
    const isSendingForm = requestPasswordResult.isLoading;

    const formError = getQueryError(requestPasswordResult);

    const handleSubmit = (fields: Record<LoginFormKeys, string>) => {
        requestPassword({ email: fields[LoginFormKeys.Email] });
    };

    useLayoutEffect(() => {
        const email = requestPasswordResult.originalArgs?.email;
        if (requestPasswordResult.isSuccess && email) {
            localStorage.removeItem(REQUEST_PASSWORD_TIMER_KEY);
            dispatch(setLogin(email));
            dispatch(setLoginStep(LoginSteps.Password));
        }
    }, [requestPasswordResult.isSuccess, requestPasswordResult.originalArgs?.email]);

    useEffect(() => {
        const input = inputRef.current;
        if (input) {
            input.focus();
        }
    }, [currentStep]);

    if (currentStep !== LoginSteps.Login) {
        return null;
    }

    return (
        <Wrapper>
            <Typography size='h4'>Авторизация</Typography>
            <Form
                subscription={{}}
                onSubmit={handleSubmit}
                validate={validate}
                render={(form) => {
                    return (
                        <FormBox onSubmit={form.handleSubmit}>
                            <Field
                                name={LoginFormKeys.Email}
                                initialValue={initialLogin}
                                render={({ meta, input }) => {
                                    return (
                                        <InputText
                                            label='Email'
                                            ref={inputRef}
                                            startAdornment={<AllUser />}
                                            placeholder='Введите e-mail'
                                            autoComplete='on'
                                            error={(meta.touched && meta.error) || formError?.message}
                                            name={input.name}
                                            value={input.value}
                                            disabled={isSendingForm}
                                            onChange={input.onChange}
                                        />
                                    );
                                }}
                            />

                            <Controls>
                                <Button fullWidth type='submit' disabled={isSendingForm} preloader={isSendingForm}>
                                    {!isSendingForm && 'Продолжить'}
                                </Button>
                            </Controls>
                        </FormBox>
                    );
                }}
            />
            <Divider />
            <FooterText>
                <Typography size='body1_long' color='neutral_50'>
                    Еще нет аккаунта?
                </Typography>
                <LinkScroll to={ROUTE_REGISTER}>Зарегистрироваться</LinkScroll>
            </FooterText>
        </Wrapper>
    );
};
